<template>
    <el-container>
        <el-main>
            <el-form :model="form" label-width="80px">
                <el-form-item label="标题" v-show="false">
                    <el-input v-model="form.title"></el-input>
                    <el-input-number
                        v-model="form.sort"
                        label="排序"
                    ></el-input-number>
                </el-form-item>
                <el-form-item>
                    <kindeditor
                        ref="kindeditorf"
                        :options="options"
                        :value="inContent"
                        @getcontent="getkindeditor"
                    ></kindeditor>
                </el-form-item>
            </el-form>
        </el-main>
        <el-footer class="cheadc">
            <el-button type="primary" @click="saveContent()">保存</el-button>
        </el-footer>
    </el-container>
</template>
<script>
import config from "../../../api/config";
import {
    editContent,
    addContent,
    getListFirst
} from "../../../api/gm/api-content";
import Kindeditor from "../../../components/kindeditor";
export default {
    data() {
        return {
            options: {
                width: "90%",
                height: "400px"
            },
            inContent: "", //编辑器输入内容
            form: {
                id: 0,
                productid: this.$route.params.id,
                relationid: this.$route.params.cid,
                relationmodel: "info",
                title: "单页",
                info: "",
                sort: 1
            },
            viewContentSearch: {
                //获取数据内容
                productid: this.$route.params.id,
                relationid: this.$route.params.cid,
                relationmodel: "info",
                isdelete: false
            }
        };
    },
    created() {
        this.fetchData();
    },
    watch: {
        $route: {
            handler: function(val, oldVal) {
                this.viewContentSearch.productid = val.params.id;
                this.viewContentSearch.relationid = val.params.cid;
                this.form.productid = val.params.id;
                this.form.relationid = val.params.cid;
                this.fetchData();
            }
        }
    },
    components: {
        kindeditor: Kindeditor
    },
    methods: {
        //..获取数据
        fetchData() {
            getListFirst(this.viewContentSearch).then(res => {
                if (res.code === 0) {
                    if (res.data != null) {
                        this.form.id = res.data.id;
                        this.form.info = res.data.info;
                        this.inContent = res.data.info;
                        //console.log(this.$refs.kindeditorf);
                        //this.$refs.kindeditorf.outContent = this.form.info;
                    } else {
                        this.form.id = 0;
                        this.form.info = "";
                        this.inContent = "";
                    }
                } else {
                    console.log(res.msg);
                }
            });
        },
        //..获取富文本编辑器内容
        getkindeditor(val) {
            this.form.info = val;
            //this.$forceUpdate();
        },
        //..清楚内容
        cleardata() {
            this.form.id = 0;
            this.form.title = "";
            this.form.info = "";
            this.form.sort = 1;
            this.inContent = "";
            this.$refs.child.clear();
        },
        //..添加内容
        saveContent() {
            if (this.form.info.trim() === "") {
                this.$message.error("请输入内容");
            } else {
                let formData = new FormData();
                Object.keys(this.form).forEach(key => {
                    if (
                        this.form[key] !== null &&
                        this.form[key] !== undefined
                    ) {
                        formData.append(key, this.form[key]);
                    }
                });

                if (this.form.id == 0) {
                    //添加
                    addContent(formData).then(res => {
                        if (res.code === 0) {
                            this.fetchData();
                            this.$message({
                                message: "编辑成功",
                                type: "success"
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    //修改
                    editContent(formData).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: "编辑成功",
                                type: "success"
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            }
        }
    }
};
</script>
<style scoped>
.el-dialog {
    margin-top: 5vh !important;
}
.cheadc {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/gm/content/info.vue